import { render, staticRenderFns } from "./app-header-account-sets.vue?vue&type=template&id=b4a9e1ca"
import script from "./app-header-account-sets.vue?vue&type=script&lang=js"
export * from "./app-header-account-sets.vue?vue&type=script&lang=js"
import style0 from "./app-header-account-sets.vue?vue&type=style&index=0&id=b4a9e1ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports